export const APP_PATHS = {
  login: 'connexion',
  samlCallback: 'saml-callback',
  forgotPassword: 'mot-de-passe-oublie',
  forgotPasswordReset: 'reinitialisation',
  activity: 'activite',
  opportunity: 'opportunite',
  newOpportunity: 'nouvelle',
  opportunityId: ':id',
  users: 'utilisateurs',
  roles: 'roles',
} as const;

export const APP_URLS = {
  root: '/',
  login: `/${APP_PATHS.login}`,
  samlCallback: `/${APP_PATHS.samlCallback}`,
  forgotPassword: `/${APP_PATHS.forgotPassword}`,
  forgotPasswordReset: `/${APP_PATHS.forgotPassword}/${APP_PATHS.forgotPasswordReset}`,
  activity: `/${APP_PATHS.activity}`,
  opportunity: `/${APP_PATHS.opportunity}`,
  newOpportunity: `/${APP_PATHS.opportunity}/${APP_PATHS.newOpportunity}`,
  users: `/${APP_PATHS.users}`,
  roles: `/${APP_PATHS.roles}`,
} as const;

export const APP_QUERY_PARAMS = {
  opportunityTab: 'onglet',
  broker: 'courtier',
} as const;
